import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MerchantOrderItemOptionsQueryVariables = Types.Exact<{
  filter: Types.MerchantOrderItemOptionsFilter;
}>;


export type MerchantOrderItemOptionsQuery = { __typename?: 'Query', merchantOrderItemOptions: Array<{ __typename?: 'MerchantOrderItemOption', type_id: number, name?: string | null, order_key: number, purchase_price_cents: number, pickup_disabled?: boolean | null, resupply_disabled?: boolean | null, resupply_disabled_until?: string | null }> };


export const MerchantOrderItemOptionsDocument = gql`
    query MerchantOrderItemOptions($filter: MerchantOrderItemOptionsFilter!) {
  merchantOrderItemOptions(filter: $filter) {
    type_id
    name
    order_key
    purchase_price_cents
    pickup_disabled
    resupply_disabled
    resupply_disabled_until
  }
}
    `;

/**
 * __useMerchantOrderItemOptionsQuery__
 *
 * To run a query within a React component, call `useMerchantOrderItemOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantOrderItemOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantOrderItemOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMerchantOrderItemOptionsQuery(baseOptions: Apollo.QueryHookOptions<MerchantOrderItemOptionsQuery, MerchantOrderItemOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantOrderItemOptionsQuery, MerchantOrderItemOptionsQueryVariables>(MerchantOrderItemOptionsDocument, options);
      }
export function useMerchantOrderItemOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantOrderItemOptionsQuery, MerchantOrderItemOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantOrderItemOptionsQuery, MerchantOrderItemOptionsQueryVariables>(MerchantOrderItemOptionsDocument, options);
        }
export type MerchantOrderItemOptionsQueryHookResult = ReturnType<typeof useMerchantOrderItemOptionsQuery>;
export type MerchantOrderItemOptionsLazyQueryHookResult = ReturnType<typeof useMerchantOrderItemOptionsLazyQuery>;
export type MerchantOrderItemOptionsQueryResult = Apollo.QueryResult<MerchantOrderItemOptionsQuery, MerchantOrderItemOptionsQueryVariables>;